module.exports = __webpack_public_path__ + "static/media/clients.cf6e13a7.png";